/**
 * Constants for check-in templates
 */

export enum CheckInTemplateType {
  STANDUP = 'standup',
  WEEKLY_CHECKIN = 'weekly_checkin',
  DAILY_STANDUP = 'daily_standup',
  RETROSPECTIVE = 'retrospective',
  ONE_ON_ONE = 'one_on_one',
  FEEDBACK = 'feedback',
  CUSTOM = 'custom',
}

export const TEMPLATE_IDS = {
  // Map template IDs to their types for easy reference
  STANDUP: 'c4ca9db0-5ff7-4bfc-9769-3cc39cfbef72',
  DAILY_STANDUP: '638ce109-af5f-45d5-ae8b-cfe2257670be',
  WEEKLY_CHECKIN: 'a764256e-7163-4569-8517-786a37a75abf',
  // Add other template IDs as needed
};

// Helper function to get template type from ID
export function getTemplateTypeFromId(templateId: string): CheckInTemplateType {
  switch (templateId) {
    case TEMPLATE_IDS.STANDUP:
      return CheckInTemplateType.STANDUP;
    case TEMPLATE_IDS.DAILY_STANDUP:
      return CheckInTemplateType.DAILY_STANDUP;
    case TEMPLATE_IDS.WEEKLY_CHECKIN:
      return CheckInTemplateType.WEEKLY_CHECKIN;
    // Add cases for other template IDs
    default:
      return CheckInTemplateType.CUSTOM;
  }
}

// Helper function to get a user-friendly name for a template type
export function getTemplateDisplayName(templateType: CheckInTemplateType): string {
  switch (templateType) {
    case CheckInTemplateType.STANDUP:
      return 'Standup';
    case CheckInTemplateType.DAILY_STANDUP:
      return 'Daily Standup';
    case CheckInTemplateType.WEEKLY_CHECKIN:
      return 'Weekly Check-in';
    case CheckInTemplateType.RETROSPECTIVE:
      return 'Retrospective';
    case CheckInTemplateType.ONE_ON_ONE:
      return 'One-on-One';
    case CheckInTemplateType.FEEDBACK:
      return 'Feedback';
    case CheckInTemplateType.CUSTOM:
      return 'Custom';
    default:
      return 'Unknown';
  }
} 